import FBBCWelcomeVideo from "../../../../../images/posters/fbbc/portal/fbbc-welcome.webp";
import ClientRegistration from "../../../../../images/posters/fbbc/portal/client-registration.webp";
import UpdateBilling from "../../../../../images/posters/fbbc/portal/update-billing.webp";
import AddingClient from "../../../../../images/posters/fbbc/portal/adding-client.webp";
import RemoveClient from "../../../../../images/posters/fbbc/portal/remove-client.webp";
import EmailExists from "../../../../../images/posters/fbbc/portal/email-already-exists.webp";
import ProviderOversight from "../../../../../images/posters/fbbc/portal/provider-oversight.webp";
import AddTrainer from "../../../../../images/posters/fbbc/portal/add-trainer.webp";
import AssignClient from "../../../../../images/posters/fbbc/portal/assign-client.webp";
import EditClientMacros from "../../../../../images/posters/fbbc/portal/edit-client-macros.webp";
import EditCheckIn from "../../../../../images/posters/fbbc/portal/edit-check-in.webp";
import Monitoring from "../../../../../images/posters/fbbc/portal/monitoring.webp";
import AnalyzingTimeline from "../../../../../images/posters/fbbc/portal/analyzing-client-timeline.webp";
import ClientsAttention from "../../../../../images/posters/fbbc/portal/clients-attention.webp";
import ChangeCheckInDay from "../../../../../images/posters/fbbc/portal/change-checkin-day.webp";
import BillingExplained from "../../../../../images/posters/fbbc/portal/billing-explained.webp";
import Templates from "../../../../../images/posters/fbbc/portal/templates.webp";
import Messaging from "../../../../../images/posters/fbbc/portal/messaging.webp";
import AddClientGroup from "../../../../../images/posters/fbbc/portal/add-client-group.webp";
import RemoveClientGroup from "../../../../../images/posters/fbbc/portal/remove-client-group.webp";
import MessagingGroup from "../../../../../images/posters/fbbc/portal/messaging-group.webp";
import TurnOnMessaging from "../../../../../images/posters/fbbc/portal/turn-on-messaging.webp";
import DailyMacroAdjustments from "../../../../../images/posters/fbbc/portal/turn-on-daily-macro-adjustments.webp";
import HighLowDays from "../../../../../images/posters/fbbc/portal/setting-high-low-days.webp";
import DailyWeights from "../../../../../images/posters/fbbc/portal/turn-on-daily-weights.webp";
import Campaigns from "../../../../../images/posters/fbbc/portal/campaigns.webp";
import VacationMode from "../../../../../images/posters/fbbc/portal/vacation-mode.webp";
import ChangeClientGoal from "../../../../../images/posters/fbbc/portal/change-client-goal.webp";
import AddTrainerNotes from "../../../../../images/posters/fbbc/portal/add-trainer-notes.webp";
import AdminVsNonAdmin from "../../../../../images/posters/fbbc/portal/admin-vs-nonadmin.webp";
import CheckInFormsPoster from "../../../../../images/posters/fbbc/portal/check-in-forms.webp";
import PausePracticeModesPoster from "../../../../../images/posters/fbbc/portal/pause-practice-modes.webp";

const fbbcPortalVideos = [
  {
    "title": "Portal Welcome Video",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Fit+Body+Nutrition+Welcome+Video.mp4",
    "thumbnail": FBBCWelcomeVideo,
    "length": "2:39"
  },
  {
    "title": "Client Registration Flow",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Client+Registration.mp4",
    "thumbnail": ClientRegistration,
    "length": "5:06"
  },
  {
    "title": "Update Billing Method",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Update+Billing+Method.mp4",
    "thumbnail": UpdateBilling,
    "length": "0:20"
  },
  {
    "title": "Adding a Client",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Adding+a+Client.mp4",
    "thumbnail": AddingClient,
    "length": "0:46"
  },
  {
    "title": "Removing a Client",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Removing+a+Client.mp4",
    "thumbnail": RemoveClient,
    "length": "0:27"
  },
  {
    "title": "Email Already Exists Error Fix",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Email+Already+Exists+Error+Fix.mp4",
    "thumbnail": EmailExists,
    "length": "0:49"
  },
  {
    "title": "Provider Oversight and Permissions",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Provider+Oversight.mp4",
    "thumbnail": ProviderOversight,
    "length": "0:16"
  },
  {
    "title": "Adding a Trainer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Adding+a+Trainer.mp4",
    "thumbnail": AddTrainer,
    "length": "0:19"
  },
  {
    "title": "Assigning a Client to a Trainer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Assigning+a+Client+to+a+Trainer.mp4",
    "thumbnail": AssignClient,
    "length": "0:30"
  },
  {
    "title": "Editing Client Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Editing+Client+Macros.mp4",
    "thumbnail": EditClientMacros,
    "length": "1:24"
  },
  {
    "title": "Editing a Check In",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Editing+a+Check+In.mp4",
    "thumbnail": EditCheckIn,
    "length": "0:52"
  },
  {
    "title": "Monitoring and Tracking Adherence",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Monitoring+Tracking+and+Adherence.mp4",
    "thumbnail": Monitoring,
    "length": "2:01"
  },
  {
    "title": "Analyzing a Client Timeline",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Analyzing+a+Client+Timeline.mp4",
    "thumbnail": AnalyzingTimeline,
    "length": "1:31"
  },
  {
    "title": "Clients in Need of Attention",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Clients+in+Need+of+Attention.mp4",
    "thumbnail": ClientsAttention,
    "length": "0:49"
  },
  {
    "title": "Change Client Check-In Day",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Change+Check+In+Day+2.mp4",
    "thumbnail": ChangeCheckInDay,
    "length": "1:18"
  },
  {
    "title": "Billing Explained",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Billing+Explained.mp4",
    "thumbnail": BillingExplained,
    "length": "1:46"
  },
  {
    "title": "Templates",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Templates.mp4",
    "thumbnail": Templates,
    "length": "1:15"
  },
  {
    "title": "Messaging",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Messaging.mp4",
    "thumbnail": Messaging,
    "length": "0:58"
  },
  {
    "title": "Adding Clients to a Group",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Adding+Clients+to+a+Group.mp4",
    "thumbnail": AddClientGroup,
    "length": "0:18"
  },
  {
    "title": "Remove Client from Group",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Remove+Client+from+Group.mp4",
    "thumbnail": RemoveClientGroup,
    "length": "0:38"
  },
  {
    "title": "Messaging Groups",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Messaging+Groups.mp4",
    "thumbnail": MessagingGroup,
    "length": "1:05"
  },
  {
    "title": "Turn on Messaging",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/turn+on+messaging.mp4",
    "thumbnail": TurnOnMessaging,
    "length": "0:11"
  },
  {
    "title": "Turn on Daily Macro Adjustments",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Turn+on+Daily+Macro+Adjustments.mp4",
    "thumbnail": DailyMacroAdjustments,
    "length": "1:06"
  },
  {
    "title": "Setting up High/Low Days",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/high+low+days.mp4",
    "thumbnail": HighLowDays,
    "length": "1:42"
  },
  {
    "title": "Turn on Daily Weights",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Turn+on+Daily+Weights.mp4",
    "thumbnail": DailyWeights,
    "length": "0:54"
  },
  {
    "title": "Campaigns",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Campaigns.mp4",
    "thumbnail": Campaigns,
    "length": "1:41"
  },
  // {
  //   "title": "Vacation Mode",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Vacation+Mode.mp4",
  //   "thumbnail": VacationMode,
  //   "length": "0:19"
  // },
  {
    "title": "Change Client Goals",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Where+to+Change+Client+Goals.mp4",
    "thumbnail": ChangeClientGoal,
    "length": "0:22"
  },
  {
    "title": "Adding Trainer Notes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Adding+Trainer+Notes.mp4",
    "thumbnail": AddTrainerNotes,
    "length": "0:24"
  },
  {
    "title": "Admin vs Non-Admin Trainers",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Admin+vs+Trainer+Difference.mp4",
    "thumbnail": AdminVsNonAdmin,
    "length": "0:37"
  },
  {
    "title": "Check-in Forms",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Check+In+Forms.mp4",
    "thumbnail": CheckInFormsPoster,
    "length": "7:04"
  },
  {
    "title": "Pause and Practice Modes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/portal/Practice+Mode+and+Pause+your+Goal.mp4",
    "thumbnail": PausePracticeModesPoster,
    "length": "3:05"
  }
]

export default fbbcPortalVideos;
